import axios from 'axios';


// Configuración de las URLs de la API
const API_URLS = {
    production: 'https://centro-infantil-mijardin.onrender.com/api/pagos/',
    development: 'http://localhost:5000/api/pagos/'
};

// URLs de redirección para dLocal Go
const REDIRECT_URLS = {
    production: 'https://centroinfantil.vercel.app/padre/pagos',
    development: 'http://localhost:3000/padre/pagos'
};


// Determinar la URL base según el entorno
const API_URL = process.env.NODE_ENV === 'production' ? API_URLS.production : API_URLS.development;

// Configuración global de axios
axios.defaults.withCredentials = true;



// Función para obtener fechas de pago por matrícula
export const obtenerFechasPago = async (id_matricula) => {
    try {
        // Validar que id_matricula no sea undefined, null o vacío
        if (!id_matricula || id_matricula === 'undefined' || id_matricula === 'null') {
            console.warn('obtenerFechasPago: id_matricula es inválido:', id_matricula);
            return {
                success: true,
                data: []
            };
        }
        
        const response = await axios.get(`${API_URL}fechas-pago/${id_matricula}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        // Si es un error 404, significa que no hay control de pagos para esta matrícula
        // Devolver un objeto con data vacía en lugar de lanzar error
        if (error.response?.status === 404) {
            console.warn(`No se encontró control de pagos para matrícula ${id_matricula}`);
            return {
                success: true,
                data: []
            };
        }
        throw new Error('Error al obtener fechas de pago: ' + (error.response?.data?.message || error.message));
    }
};

// Función para realizar pago por transferencia
export const pagoTransferencia = async (amount, id_matricula, mes_pagado, anio_pagado, imagen_comprobante, codigo_transferencia, id_plan_seleccionado = null) => {
    try {
        // Convertir la imagen a base64 si no lo está ya
        let imagenBase64 = imagen_comprobante;
        if (imagen_comprobante instanceof File) {
            const reader = new FileReader();
            imagenBase64 = await new Promise((resolve) => {
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(imagen_comprobante);
            });
        }

        const requestData = {
            amount: parseFloat(amount), // Convertir a número como en testPago
            id_matricula: parseInt(id_matricula),
            mes_pagado: parseInt(mes_pagado),
            anio_pagado: parseInt(anio_pagado),
            imagen_comprobante: imagen_comprobante,
            codigo_transferencia: codigo_transferencia,
            id_plan_seleccionado: id_plan_seleccionado ? parseInt(id_plan_seleccionado) : null
        };

        console.log('URL completa:', `${API_URL}transferencia-payment`);
        console.log('API_URL:', API_URL);
        console.log('NODE_ENV:', process.env.NODE_ENV);
        
        const response = await axios.post(`${API_URL}transferencia-payment`, requestData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity
        });
        
        if (!response.data) {
            throw new Error('No se recibió respuesta del servidor');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error completo:', error);
        let mensajeError = 'Error al realizar el pago por transferencia';
        
        if (error.response?.data?.error) {
            mensajeError += ': ' + error.response.data.error;
        } else if (error.message) {
            mensajeError += ': ' + error.message;
        }
        
        throw new Error(mensajeError);
    }
};

// Función para verificar el estado de un pago con dLocal Go
export const verificarEstadoPagoDLocalGo = async (payment_id) => {
    try {
        const response = await axios.get(`${API_URL}dlocal-go-payment/${payment_id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al verificar estado del pago:', error);
        throw new Error('Error al verificar estado del pago: ' + (error.response?.data?.message || error.message));
    }
};

// Función para obtener todos los controles de pago
export const obtenerTodosControlPagos = async () => {
    try {
        const response = await axios.get(`${API_URL}control-pagos`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        
        if (!response || !response.data) {
            throw new Error('No se recibió respuesta del servidor');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error completo al obtener controles de pago:', error);
        let mensajeError = 'Error al obtener los controles de pago';
        
        if (error.response?.data?.message) {
            mensajeError += ': ' + error.response.data.message;
        } else if (error.message) {
            mensajeError += ': ' + error.message;
        }
        
        throw new Error(mensajeError);
    }
};

// Función para procesar (aprobar/rechazar) una transferencia
export const procesarTransferencia = async (id_control, accion) => {
    try {
        const response = await axios.post(`${API_URL}procesar-transferencia/${id_control}`, {
            accion
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al procesar la transferencia: ' + error.response?.data?.message || error.message);
    }
};

// Función para realizar pago en efectivo
export const pagoEfectivo = async (amount, id_matricula, mes_pagado, anio_pagado, cobrador) => {
    try {
        const response = await axios.post(`${API_URL}efectivo-payment`, {
            amount,
            id_matricula,
            mes_pagado, 
            anio_pagado,
            cobrador
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al procesar el pago en efectivo: ' + error.response?.data?.message || error.message);
    }
};

// Función para verificar si una matrícula tiene pagos anteriores en el historial
export const verificarPagosAnterioresHistorial = async (id_matricula) => {
    try {
        const response = await axios.get(`${API_URL}verificar-pagos-anteriores/${id_matricula}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al verificar pagos anteriores:', error);
        // En caso de error, asumir que es primera vez para evitar bloqueos
        return {
            success: true,
            tienePagosAnteriores: false,
            cantidadPagos: 0,
            message: 'Error al verificar, asumiendo primera vez'
        };
    }
};

// Función para crear pago con dLocal Go (simplificada)
export const crearPagoDLocalGo = async (id_matricula) => {
    try {
        const response = await axios.post(`${API_URL}dlocal-go-payment`, {
            id_matricula
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error completo al crear pago con dLocal Go:', error);
        let mensajeError = 'Error al crear el pago con dLocal Go';
        
        if (error.response?.data?.error) {
            mensajeError += ': ' + error.response.data.error;
        } else if (error.response?.data?.message) {
            mensajeError += ': ' + error.response.data.message;
        } else if (error.message) {
            mensajeError += ': ' + error.message;
        }
        
        throw new Error(mensajeError);
    }
};

// Nuevo servicio para pago múltiple
export const crearPagoMultipleDLocalGo = async (matriculas) => {
    try {
        const response = await axios.post(`${API_URL}dlocal-go-payment-multiple`, {
            matriculas
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error completo al crear pago múltiple con dLocal Go:', error);
        let mensajeError = 'Error al crear el pago múltiple con dLocal Go';
        
        if (error.response?.data?.error) {
            mensajeError += ': ' + error.response.data.error;
        } else if (error.response?.data?.message) {
            mensajeError += ': ' + error.response.data.message;
        } else if (error.message) {
            mensajeError += ': ' + error.message;
        }
        
        throw new Error(mensajeError);
    }
};

// Función para verificar el estado de un pago múltiple con dLocal Go
export const verificarEstadoPagoMultipleDLocalGo = async (payment_id) => {
    try {
        const response = await axios.get(`${API_URL}dlocal-go-payment-multiple/${payment_id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al verificar estado del pago múltiple:', error);
        throw new Error('Error al verificar estado del pago múltiple: ' + (error.response?.data?.message || error.message));
    }
};
